import { branch, compose, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { toggleBombBomb } from 'src/actions/bombBomb'

const ControlButtonContainer = compose(
  connect(
    ({ bombBomb }) => ({
      initialized: bombBomb.initialized,
      open: bombBomb.open
    }),
    dispatch => ({
      toggleBombBomb: () => dispatch(toggleBombBomb())
    })
  ),
  branch(({ initialized }) => !initialized, renderNothing)
)

export default ControlButtonContainer
